import { c as _c } from "react/compiler-runtime";
import React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { Icon } from "../Icon";
import type { IconName } from "@/types/icons";
import type { ThemeVariant } from "@/types/common";
const tabItemVariants = cva("grow-0 shrink-0 basis-[calc(50%-var(--spacing-sm))] flex items-center gap-sm px-md py-sm transition-all cursor-pointer rounded-l-full rounded-r-full font-weight-medium text-left text-sm outline-offset-0 focus-visible:outline-2 focus-visible:outline-offset-2", {
  variants: {
    variant: {
      light: "outline-yellow",
      dark: "outline-purple"
    },
    isActive: {
      true: "",
      false: ""
    }
  },
  compoundVariants: [{
    variant: "dark",
    isActive: true,
    className: "bg-purple text-white"
  }, {
    variant: "dark",
    isActive: false,
    className: "bg-transparent text-black hover:bg-black/10 hover:text-purple-medium"
  }, {
    variant: "light",
    isActive: true,
    className: "bg-yellow text-black"
  }, {
    variant: "light",
    isActive: false,
    className: "bg-transparent text-white hover:bg-black/30 hover:text-yellow"
  }],
  defaultVariants: {
    variant: "light",
    isActive: false
  }
});
interface TabItemProps extends VariantProps<typeof tabItemVariants> {
  label: string;
  icon?: IconName;
  variant?: ThemeVariant;
  onClick: () => void;
  className?: string;
}

/**
 * Individual tab item for use in TabBar
 */
export const TabItem: React.FC<TabItemProps> = t0 => {
  const $ = _c(15);
  const {
    label,
    icon,
    isActive,
    variant: t1,
    onClick,
    className: t2
  } = t0;
  const variant = t1 === undefined ? "light" : t1;
  const className = t2 === undefined ? "" : t2;
  const iconColor = variant === "dark" ? isActive ? "text-yellow" : "text-purple" : isActive ? "text-purple" : "text-yellow";
  let t3;
  if ($[0] !== className || $[1] !== isActive || $[2] !== variant) {
    t3 = tabItemVariants({
      variant,
      isActive,
      className
    });
    $[0] = className;
    $[1] = isActive;
    $[2] = variant;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const t4 = isActive ?? false;
  let t5;
  if ($[4] !== icon || $[5] !== iconColor) {
    t5 = icon && <Icon name={icon} className={`w-6 h-6 ${iconColor}`} />;
    $[4] = icon;
    $[5] = iconColor;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label) {
    t6 = <span className="">{label}</span>;
    $[7] = label;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== onClick || $[10] !== t3 || $[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <button type="button" onClick={onClick} className={t3} aria-pressed={t4}>{t5}{t6}</button>;
    $[9] = onClick;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};